import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Ripple } from "primereact/ripple";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { confirmDialog } from "primereact/confirmdialog";
import { Message } from "primereact/message";

import NoDataCreated from "../../Components/NoDataCreated";
import ErrorPage from "../../Components/ErrorPage";
import TextInput from "../../Components/TextInput";
import DocumentViewModal from "../../Components/DocumentViewModal";
import { goToTop } from "../../Components/goToTop";
import { getLoginUserRoleName, UserRoleName } from "../../Utils/LoginUserRoleName";
import { getAppCurrencyType } from "../../Utils/Common";
import { checkEmail, checkText } from "../../Utils/Validator";

import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { useSelector } from "react-redux";
import { RootState } from "../../Controllers/Store";
import { hasPermission } from "../../Controllers/Selectors/permissionsSelector";

import {
    QuotationCoverPage,
    QuotationList as QuotationListType,
    QuotationNoteList,
    QuotationSOWData,
    QuotationTermData,
    Quotation as QuotationType
} from "../../Controllers/Types/Quotation/QuotationType";
import { fetchQuotationData } from "../../Controllers/Thunks/QuotationThunks";
import { InputText } from "primereact/inputtext";
import { nextCreateQuotation, removeSignQuotation, sendEmailQuotation, signQuotation } from "../../Api/Quotation/QuotationApiService";


const QuotationReport: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const toast = useRef<Toast>(null);
    const dispatch = useAppDispatch();
    const currencySymbol = getAppCurrencyType();

    const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | ''>('');
    const [loading, setLoading] = useState<boolean>(false);

    const quotationNo: number | null = location?.state?.quotationNo;
    // const quotationDetail: QuotationListType | null = location?.state?.quotationDetail;
    const GlobalQuotationDetail: QuotationListType | null = location?.state?.quotationDetail;
    const globalQuotation: QuotationType | null = location?.state?.quotation;

    const [quotation, setQuotation] = useState<QuotationType | null>(null);
    const [quotationDetail, setQuotationDetails] = useState<QuotationListType | null>(null);


    const reportType: 'Simple' | 'Detail' = location?.state?.reportType;
    const reportView: string[] = location?.state?.reportView;
    const headerContent: string = location?.state?.headerContent;
    const footerContent: string = location?.state?.footerContent;

    const loadingQuotation: boolean = useAppSelector((state) => state?.quotationList?.loadingQuotation);
    const quotations: QuotationType[] = useAppSelector((state) => state?.quotationList?.quotations);
    const errorQuotation: string | null = useAppSelector((state) => state?.quotationList?.errorQuotation);

    const [isSimpleReportSigned, setIsSimpleReportSigned] = useState<boolean>(false);
    const [isDetailReportSigned, setIsDetailReportSigned] = useState<boolean>(false);

    const [coverPageData, setCoverPageData] = useState<QuotationCoverPage | null>(null);
    const [termsData, setTermsData] = useState<QuotationTermData | null>(null);
    const [notesData, setNotesData] = useState<QuotationNoteList[]>([]);
    const [sowData, setSOWData] = useState<QuotationSOWData | null>(null);

    const [showSignPublishModal, setShowSignPublishModal] = useState<boolean>(false);
    const [signature, setSignature] = useState<string>("");
    const [signatureError, setSignatureError] = useState<string>("");

    const [showMailModal, setShowMailModal] = useState<boolean>(false);
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [emailAddressError, setEmailAddressError] = useState<string>("");
    const [showFileViewModal, setShowFileViewModal] = useState<boolean>(false);
    const [fileUrl, setFileUrl] = useState<string>("");
    const [isDownloading, setIsDownloading] = useState<boolean>(false);
    const [anyDraft, setAnyDraft] = useState<boolean>(false);

    // PERMISION HANDLER
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) =>
            hasPermission(state, screen, permission)
        );
    };

    // Get logged in user role name
    useEffect(() => {
        const fetchUserRole = async () => {
            const roleName = await getLoginUserRoleName();
            setLoginUserRoleName(roleName);
        };

        fetchUserRole();
    }, []);

    // load globlal state quotations
    useEffect(() => {
        dispatch(fetchQuotationData());

    }, [dispatch]);


    const quatations = useAppSelector((state) => state.quotationList.quotations);

    useEffect(() => {
        const list = quatations.filter(
            (e) => e.id === globalQuotation?.id
        );
        if (list?.length > 0) {
            setQuotation(list[0] as QuotationType);
        }
    }, [quatations]);

    // now get current quotation listtype

    useEffect(() => {
        const list = quotation?.quotation_data.filter(
            (e) => e.id === GlobalQuotationDetail?.id
        );

        // any draft or this report draft

        const darftlist = quotation?.quotation_data.filter(
            (e) => e.status === "Draft"
        );
        if (darftlist && darftlist?.length > 0) {

            if (darftlist[0].id === quotationDetail?.id) {
                setAnyDraft(false);
            } else {
                setAnyDraft(true);
            }

        } else {
            setAnyDraft(false);
        }



        if (list && list?.length > 0) {
            setQuotationDetails(list[0] as QuotationListType);
        }
    }, [quotation]);









    useEffect(() => {
        if (quotationDetail && quotationDetail !== null) {
            setIsSimpleReportSigned(quotationDetail?.sign_report === 1 ? true : false);
            setIsDetailReportSigned(quotationDetail?.detail_sign_report === 1 ? true : false);

            setCoverPageData(quotationDetail?.cover_page_data || null);
            setTermsData(quotationDetail?.term_data || null);
            setNotesData(quotationDetail?.note_list || []);
            setSOWData(quotationDetail?.sow_data || null);
        } else {
            setIsSimpleReportSigned(false);
            setIsDetailReportSigned(false);

            setCoverPageData(null);
            setTermsData(null);
            setNotesData([]);
            setSOWData(null);
        }
    }, [quotationDetail]);


    /* **************************************************************** Sign and publish */
    const handleCloseSignPublishModal = () => {
        setShowSignPublishModal(false);
        handleResetSignPublishFields();
    }

    const handleResetSignPublishFields = () => {
        setSignature('');
        setSignatureError('');
    }

    const handleAddSignature = () => {
        setShowSignPublishModal(true);
    }

    function checkSignReportCredentials(): boolean {
        const isSignatureValid = checkText(signature, true, setSignatureError);
        return isSignatureValid;
    }

    function showAPIErrorSignReport(keyName: string, error: string): void {
        if (keyName === "sign") {
            setSignatureError(error);
        }
    }

    useEffect(() => {
        checkText(signature, false, setSignatureError)
    }, [signature]);

    // database function for handle publish report.
    const signAndPublishReport = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkSignReportCredentials()) {
            setLoading(true);

            let filterdata = reportView.filter((e) => ((e === "Material" || e === "Labour" || e === "Total")));
            const data = await signQuotation(
                quotationDetail?.id!,
                signature,
                headerContent,
                footerContent,
                reportType,
                filterdata,
            );
            if (data.statusCode === 200) {
                await dispatch(fetchQuotationData());

                setLoading(false);
                handleCloseSignPublishModal();
                dispatch(fetchQuotationData);

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: `The ${reportType.toLowerCase()} quotation report has been signed and published successfully.`,
                        life: 3000
                    });
                }
            } else {
                setLoading(false);
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'An error occurred while signing the quotation report.',
                        life: 3000
                    });
                }
            }
        }
    }

    const signPublishModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">Sign and publish</h5>

            <button
                type="button"
                className="close_modal_btn p-ripple"
                onClick={handleCloseSignPublishModal}
            >
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const signPublishModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Cancel"
                className="custom_btn secondary"
                onClick={handleCloseSignPublishModal}
            />
            <Button
                loading={loading}
                label={loading ? "Processing" : "Publish"}
                className="custom_btn primary"
                onClick={signAndPublishReport}
            />
        </div>
    );
    /* **************************************************************** */


    /* **************************************************************** Mail */
    const handleCloseMailModal = () => {
        setShowMailModal(false);
        setEmailAddress("");
    };

    const handleAddEmail = () => {
        setShowMailModal(true);
    };

    function checkCredentialsEmail(): boolean {
        const mail = checkEmail(emailAddress, true, setEmailAddressError);
        return mail;
    }

    const handleEditReport = () => {
        confirmDialog({
            message: 'Are you sure, want to alter this quotation report?',
            header: 'Confirmation',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-success',
            accept: () => editReport(),
            resizable: false,
            draggable: false,
        });
    }

    // db function
    const editReport = async () => {
        const data = await removeSignQuotation(
            quotationDetail?.id!,
            reportType,
        );

        if (data.statusCode === 200) {
            await dispatch(fetchQuotationData());
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Permision updated successfully.',
                    life: 3000
                });
            }

            // navigate
            navigate(`/quotation/list`, {
                state: {
                    quotation: quotation
                }
            })
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'There was an error grand permision.',
                    life: 3000
                });
            }
        }
    }

    useEffect(() => {
        checkEmail(emailAddress, false, setEmailAddressError);
    }, [emailAddress]);

    function showAPIErrorEmail(keyName: string, error: string): void {
        if (keyName === "email") {
            setEmailAddressError(error);
        }
    }

    // sent email fncion
    const handleSendEmail = async (e: React.FormEvent) => {
        e.preventDefault();
        if (checkCredentialsEmail()) {
            setLoading(true);

            const data = await sendEmailQuotation(
                quotationDetail?.id!,
                emailAddress,
                reportType,
            );
            if (data.statusCode === 200) {
                await dispatch(fetchQuotationData());
                setLoading(false);
                handleCloseMailModal();
                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Email sent successfully.',
                        life: 3000
                    });
                }
            } else {
                setLoading(false);
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error sending the email.',
                        life: 3000
                    });
                }
            }
        }
    }

    const mailModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">Send report via mail</h5>
            <button
                type="button"
                className="close_modal_btn p-ripple"
                onClick={handleCloseMailModal}
            >
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const mailModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Cancel"
                className="custom_btn secondary"
                onClick={handleCloseMailModal}
            />
            <Button
                loading={loading}
                label={`${loading ? "Sending" : "Send"}`}
                className="custom_btn primary"
                onClick={handleSendEmail}
            />
        </div>
    );

    const handleViewReportDocument = () => {
        if (reportType === 'Simple' && quotationDetail?.simple_report_download_path) {
            setShowFileViewModal(true);
            setFileUrl(quotationDetail?.simple_report_download_path);
        } else if (reportType === 'Detail' && quotationDetail?.detail_report_download_path) {
            setShowFileViewModal(true);
            setFileUrl(quotationDetail?.detail_report_download_path);
        }
    };

    const handleCloseFileViewModal = () => {
        setShowFileViewModal(false);
    };
    /* **************************************************************** */


    /* **************************************************************** Download */
    const handleDownloadReport = async () => {
        if (isDownloading) return;

        let reportPath: string | null = null;

        if (reportType === 'Simple' && quotationDetail?.simple_report_download_path) {
            reportPath = quotationDetail?.simple_report_download_path;
        } else if (reportType === 'Detail' && quotationDetail?.detail_report_download_path) {
            reportPath = quotationDetail?.detail_report_download_path;
        } else {
            reportPath = null;
        }

        if (reportPath === null) {
            if (toast.current) {
                toast.current.show({
                    severity: "error",
                    summary: "Failed",
                    detail: "File not found!",
                    life: 3000,
                });
            }
            return;
        }

        setIsDownloading(true);

        setTimeout(async () => {
            try {
                const response = await fetch(reportPath!);

                if (!response.ok) {
                    throw new Error("Failed to fetch the file.");
                }

                const blob = await response.blob();
                const blobUrl = URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = reportPath?.split("/").pop() || `Quotation report (${reportType}).pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);

                if (toast.current) {
                    toast.current.show({
                        severity: "success",
                        summary: "Success",
                        detail: "File downloaded successfully.",
                        life: 3000,
                    });
                }
            } catch (error) {
                if (toast.current) {
                    toast.current.show({
                        severity: "error",
                        summary: "Failed",
                        detail: "Error downloading the file",
                        life: 3000,
                    });
                }
            } finally {
                setIsDownloading(false);
            }
        }, 500);
    };
    /* **************************************************************** */


    /* **************************************************************** New report */
    const handleNewReport = () => {
        confirmDialog({
            message: 'Are you sure, want to alter this quotation as new report?',
            header: 'Confirmation',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-success',
            accept: () => createNewReport(),
            resizable: false,
            draggable: false,
        });
    }

    const createNewReport = async () => {
        // call new report function
        const data = await nextCreateQuotation(
            quotationDetail?.id!,
        );

        if (data.statusCode === 200) {
            await dispatch(fetchQuotationData());
            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: `The new report created successfully.`,
                    life: 3000
                });
            }
            // navigate
            navigate(`/quotation/list`, {
                state: {
                    quotation: quotation
                }
            })
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'An error occurred while creating the new report.',
                    life: 3000
                });
            }
        }
    }
    /* **************************************************************** */
    const checkOption = (option: 'Full' | 'Material' | 'Labour' | 'Total'): boolean => {
        return reportView?.includes(option) ?? false;
    };

    const getVisibleColumnsCount = () => {
        let count = 0;
        if (checkOption("Material") || checkOption("Full")) count++;
        if (checkOption("Labour") || checkOption("Full")) count++;
        if (checkOption("Total") || checkOption("Full")) count++;
        return count;
    };



    /* **************************************************************** Common functions */
    const goBack = () => {
        navigate(-1);
        goToTop();
    };
    /* **************************************************************** */

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content full_screen_view">
                {loadingQuotation ? (
                    <div className="loading_container">
                        <ProgressSpinner
                            className="progresscircle custom"
                            style={{ width: '50px', height: '50px', stroke: '#8953D7' }}
                            strokeWidth="8" fill="var(--surface-ground)"
                            animationDuration="1s"
                        />
                    </div>
                ) : errorQuotation ? (
                    <ErrorPage errorMessage={errorQuotation} containerClassname="full_height" />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-3)}>
                                    Quotation
                                </li>

                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-2)}>
                                    Quotation {quotationNo ? String(quotationNo).padStart(2, '0') : ''}
                                </li>

                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                    {quotationDetail ? quotationDetail?.quotation_no : ''}
                                </li>

                                <li className="page_breadcrumb_item active">
                                    Quotation Report&nbsp;({reportType})
                                </li>
                            </ul>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_header_area justify-content-end mt-sm-3 mt-2">
                            <div className="page_action_area">
                                {((reportType === 'Simple' && quotationDetail?.simple_report_download_path) ||
                                    (reportType === 'Detail' && quotationDetail?.detail_report_download_path)) && (
                                        <React.Fragment>
                                            <button
                                                className="add_data_link_btn p-ripple"
                                                onClick={handleDownloadReport}
                                                disabled={isDownloading}
                                            >
                                                {isDownloading ? (
                                                    <ProgressSpinner
                                                        style={{ width: "20px", height: "20px" }}
                                                        strokeWidth="5"
                                                        fill="none"
                                                        animationDuration="1s"
                                                        className="spin_loader"
                                                    />
                                                ) : (
                                                    <i className="bi bi-download"></i>
                                                )}
                                                <span>{isDownloading ? "Downloading" : "Download"}</span>
                                                <Ripple />
                                            </button>

                                            <button
                                                className="add_data_link_btn p-ripple"
                                                onClick={handleAddEmail}
                                            >
                                                <i className="bi bi-envelope"></i>
                                                <span>Send </span>
                                                <Ripple />
                                            </button>

                                            {(quotationDetail.share_list && quotationDetail.share_list?.length === 0) && (<button
                                                className="add_data_link_btn p-ripple"
                                                onClick={handleEditReport}
                                            >
                                                <i className="bi bi-pencil-square"></i>
                                                <span>Edit</span>
                                                <Ripple />
                                            </button>)}
                                        </React.Fragment>
                                    )}

                                {((reportType === 'Simple' && isSimpleReportSigned === false) ||
                                    (reportType === 'Detail' && isDetailReportSigned === false)) && quotationDetail?.can_edit && (
                                        <button
                                            className="add_data_link_btn p-ripple"
                                            onClick={handleAddSignature}
                                        >
                                            <i className="bi bi-send"></i>
                                            <span>Sign & Publish</span>
                                            <Ripple />
                                        </button>
                                    )}


                                {/* need to chek any draft */}

                                {(isSimpleReportSigned || isDetailReportSigned) && anyDraft === false && quotationDetail?.shared_by == null && (
                                    <button
                                        className="add_data_link_btn p-ripple"
                                        onClick={handleNewReport}
                                    >
                                        <i className="bi bi-plus-circle"></i>
                                        <span>New report</span>
                                        <Ripple />
                                    </button>
                                )}
                            </div>
                        </div>

                        {quotationDetail && quotationDetail !== null ? (
                            <article className="site_visit_report_container">
                                <div className="sv_report_body">
                                    {/* Report header */}
                                    <React.Fragment>
                                        {(reportType === 'Simple' && quotationDetail?.simple_permission_data?.header) ? (
                                            <div className="report_header">
                                                <h6>{quotationDetail?.simple_permission_data?.header}</h6>
                                            </div>
                                        ) : (reportType === 'Detail' && quotationDetail?.detail_permission_data?.header) ? (
                                            <div className="report_header">
                                                <h6>{quotationDetail?.detail_permission_data?.header}</h6>
                                            </div>
                                        ) : headerContent ? (
                                            <div className="report_header">
                                                <h6>{headerContent}</h6>
                                            </div>
                                        ) : null}
                                    </React.Fragment>

                                    {/* Report content */}
                                    <div className="site_visit_report_detail_area">
                                        <div className="row site_visit_report_detail_row">
                                            {/* Cover page */}
                                            <div className="col-12 col-lg-6">
                                                <div className="site_visit_report_detail_sub">
                                                    <div className="table-responsive">
                                                        <table className="table table-borderless">
                                                            <thead>
                                                                <tr className="vertical_align_top">
                                                                    <th className="pb-1">Cover Page</th>
                                                                    {coverPageData?.comapany_logo && (
                                                                        <th className="img_column pb-1" colSpan={2}>
                                                                            <img
                                                                                src={coverPageData?.comapany_logo}
                                                                                alt=""
                                                                                className="cover_page_logo"
                                                                            />
                                                                        </th>
                                                                    )}
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                <tr>
                                                                    <td className="text_bold">Company Name:</td>
                                                                    <td className="text-capitalize">
                                                                        <span>
                                                                            {coverPageData?.comapany_name ? coverPageData?.comapany_name : '----'}&nbsp;
                                                                        </span>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="text_bold">Project Description:</td>
                                                                    <td className="first_letter_capitalized">
                                                                        <span>
                                                                            {coverPageData?.project_description ? coverPageData?.project_description : '----'}&nbsp;
                                                                        </span>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="text_bold">Project Address:</td>
                                                                    <td className="text-capitalize">
                                                                        <span>
                                                                            {coverPageData?.project_address ? coverPageData?.project_address : '----'}&nbsp;
                                                                        </span>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="text_bold">Client Name:</td>
                                                                    <td className="text-capitalize">
                                                                        <span>
                                                                            {coverPageData?.client_name ? coverPageData?.client_name : '----'}&nbsp;
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Project overview */}
                                            <div className="col-12 col-lg-6">
                                                <div className="site_visit_report_detail_sub">
                                                    <div className="table-responsive">
                                                        <table className="table table-borderless">
                                                            <thead>
                                                                <tr>
                                                                    <th colSpan={2}>Project overview</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="text_bold">Advance Payment:</td>
                                                                    <td className="text-capitalize">
                                                                        <span>
                                                                            {termsData?.advance_payment ? `${currencySymbol} ${(termsData?.advance_payment).toFixed(2)}` : '----'}&nbsp;
                                                                        </span>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="text_bold">Start Date:</td>
                                                                    <td className="first_letter_capitalized">
                                                                        <span>
                                                                            {termsData?.start_date ? termsData?.start_date : '----'}&nbsp;
                                                                        </span>
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="text_bold">Duration ({termsData?.duration_type}):</td>
                                                                    <td className="text-capitalize">
                                                                        <span>
                                                                            {termsData?.duration ? `${String(termsData?.duration).padStart(2, '0')} ${termsData?.duration_type}(s)` : '----'}&nbsp;
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Notes */}
                                            {notesData && notesData?.length > 0 && (
                                                <div className="col-12">
                                                    <div className="site_visit_report_detail_sub">
                                                        <h6 className="site_visit_report_detail_head">Notes:</h6>

                                                        {notesData?.map((note) => {
                                                            return (
                                                                <article key={`note_${note?.id}`} className="note_content_container edge">
                                                                    <div className="note_content_area">
                                                                        <p>{String(note?.note_no).padStart(2, '0')}.&nbsp;</p>
                                                                        <p>
                                                                            {note?.note}
                                                                        </p>
                                                                    </div>
                                                                </article>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {sowData && sowData !== null ? (
                                        <div className="sv_report_table_area table-responsive pl_table_area">
                                            {reportType === 'Simple' && (sowData?.simple_data && sowData?.simple_data !== null) && (
                                                <table className="table table-bordered sv_report_table pl_table mb-0">
                                                    <thead>
                                                        <tr className="sv_report_table_header light">
                                                            <th style={{ width: "31%" }} className="head_column">
                                                                Item
                                                            </th>

                                                            {(checkOption('Material') || checkOption('Full')) && (
                                                                <th style={{ width: "23%" }} className="value_column text-center">
                                                                    Material ({currencySymbol})
                                                                </th>
                                                            )}

                                                            {(checkOption('Labour') || checkOption('Full')) && (
                                                                <th style={{ width: "23%" }} className="value_column text-center">
                                                                    Labour ({currencySymbol})
                                                                </th>
                                                            )}

                                                            {(checkOption('Total') || checkOption('Full')) && (
                                                                <th style={{ width: "23%" }} className="value_column text-center">
                                                                    Total ({currencySymbol})
                                                                </th>
                                                            )}
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {sowData?.simple_data?.simple_data_list?.map((simpleData) => {
                                                            return (
                                                                <React.Fragment>
                                                                    <tr key={`simpleData_${simpleData?.id}`} className="sv_report_table_data data_group_row quotation_table_data_row">
                                                                        <td colSpan={getVisibleColumnsCount()}>
                                                                            {simpleData?.quotation_item_name ? simpleData?.quotation_item_name : '--'}
                                                                        </td>
                                                                        <td className="text-center value_column">
                                                                            {currencySymbol}&nbsp;{(simpleData?.item_total || 0)?.toFixed(2)}
                                                                        </td>
                                                                    </tr>

                                                                    {simpleData?.sub_item_list && simpleData?.sub_item_list?.length > 0 && (
                                                                        <React.Fragment>
                                                                            {simpleData?.sub_item_list?.map((simpleSubItem) => {
                                                                                const materialAmount = (simpleSubItem?.sub_item_simple_data?.material)?.toFixed(2);
                                                                                const labourAmount = (simpleSubItem?.sub_item_simple_data?.labour)?.toFixed(2);
                                                                                const totalAmount = (simpleSubItem?.final_total)?.toFixed(2);

                                                                                return (
                                                                                    <tr
                                                                                        key={`simpleSubItem_${simpleSubItem?.id}`}
                                                                                        className="sv_report_table_data inner_tabel_row quotation_table_data_row_sub">

                                                                                        <td style={{ width: "31%" }} className="text_semi_bold head_column">
                                                                                            {simpleSubItem?.quotation_sub_item_name}
                                                                                        </td>

                                                                                        {(checkOption('Material') || checkOption('Full')) && (
                                                                                            <td style={{ width: "23%" }} className="text_semi_bold value_column text-center">
                                                                                                {materialAmount ? materialAmount : '--'}
                                                                                            </td>
                                                                                        )}

                                                                                        {(checkOption('Labour') || checkOption('Full')) && (
                                                                                            <td style={{ width: "23%" }} className="text_semi_bold value_column text-center">
                                                                                                {labourAmount ? labourAmount : '--'}
                                                                                            </td>
                                                                                        )}

                                                                                        {(checkOption('Total') || checkOption('Full')) && (
                                                                                            <td style={{ width: "23%" }} className="text_semi_bold value_column text-center">
                                                                                                {totalAmount ? totalAmount : '--'}
                                                                                            </td>
                                                                                        )}
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </React.Fragment>
                                                                    )}
                                                                </React.Fragment>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            )}

                                            {reportType === 'Detail' && (sowData?.detail_data && sowData?.detail_data !== null) && (
                                                <table className="table table-bordered sv_report_table pl_table mb-0">
                                                    <thead>
                                                        <tr className="sv_report_table_header light">
                                                            <th style={{ width: "20%" }} className="head_column">
                                                                Item.
                                                            </th>

                                                            <th style={{ width: "10%" }} className="sub_head_column text-center">
                                                                Unit
                                                            </th>

                                                            <th style={{ width: "15%" }} className="value_column text-center">
                                                                Price ({currencySymbol})
                                                            </th>

                                                            <th style={{ width: "10%" }} className="sub_head_column text-center">
                                                                QTY.
                                                            </th>

                                                            {(checkOption('Material') || checkOption('Full')) && (
                                                                <th style={{ width: "15%" }} className="value_column text-center">
                                                                    Material ({currencySymbol})
                                                                </th>
                                                            )}

                                                            {(checkOption('Labour') || checkOption('Full')) && (
                                                                <th style={{ width: "15%" }} className="value_column text-center">
                                                                    Labour ({currencySymbol})
                                                                </th>
                                                            )}

                                                            {(checkOption('Total') || checkOption('Full')) && (
                                                                <th style={{ width: "15%" }} className="value_column text-center">
                                                                    Total ({currencySymbol})
                                                                </th>
                                                            )}
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {sowData?.detail_data?.detail_data_list?.map((detailData) => {
                                                            return (
                                                                <React.Fragment>
                                                                    <tr key={`detailData_${detailData?.id}`} className="sv_report_table_data data_group_row">
                                                                        <td colSpan={getVisibleColumnsCount() + 3}>
                                                                            {detailData?.quotation_item_name}
                                                                        </td>
                                                                        <td className="text-center value_column">
                                                                            {currencySymbol}&nbsp;{(detailData?.item_total || 0)?.toFixed(2)}
                                                                        </td>
                                                                    </tr>

                                                                    {detailData?.sub_item_list && detailData?.sub_item_list?.length > 0 && (
                                                                        <React.Fragment>
                                                                            {detailData?.sub_item_list?.map((detailSubItem) => {
                                                                                const unit = detailSubItem?.sub_item_detail_data?.unit?.unit_name || '';
                                                                                const unitPrice = (detailSubItem?.sub_item_detail_data?.unit_price)?.toFixed(2);
                                                                                const quantity = detailSubItem?.sub_item_detail_data?.quantity || '';
                                                                                const materialAmount = (detailSubItem?.sub_item_detail_data?.material_cost)?.toFixed(2);
                                                                                const labourAmount = (detailSubItem?.sub_item_detail_data?.labour_cost)?.toFixed(2);
                                                                                const totalAmount = (detailSubItem?.final_total)?.toFixed(2);

                                                                                return (
                                                                                    <tr
                                                                                        key={`detailSubItem_${detailSubItem?.id}`}
                                                                                        className="sv_report_table_data inner_tabel_row quotation_table_data_row_sub"                                                                                    >
                                                                                        <td style={{ width: "20%" }} className="text_semi_bold head_column">
                                                                                            {detailSubItem?.quotation_sub_item_name}
                                                                                        </td>

                                                                                        <td style={{ width: "10%" }} className="text_semi_bold sub_head_column text-center">
                                                                                            {unit ? unit : '--'}
                                                                                        </td>

                                                                                        <td style={{ width: "15%" }} className="text_semi_bold value_column text-center">
                                                                                            {unitPrice ? unitPrice : '--'}
                                                                                        </td>

                                                                                        <td style={{ width: "10%" }} className="text_semi_bold sub_head_column text-center">
                                                                                            {quantity ? quantity : '--'}
                                                                                        </td>

                                                                                        {(checkOption('Material') || checkOption('Full')) && (
                                                                                            <td style={{ width: "15%" }} className="text_semi_bold value_column text-center">
                                                                                                {materialAmount ? materialAmount : '--'}
                                                                                            </td>
                                                                                        )}

                                                                                        {(checkOption('Labour') || checkOption('Full')) && (
                                                                                            <td style={{ width: "15%" }} className="text_semi_bold value_column text-center">
                                                                                                {labourAmount ? labourAmount : '--'}
                                                                                            </td>
                                                                                        )}

                                                                                        {(checkOption('Total') || checkOption('Full')) && (
                                                                                            <td style={{ width: "15%" }} className="text_semi_bold value_column text-center">
                                                                                                {totalAmount ? totalAmount : '--'}
                                                                                            </td>
                                                                                        )}
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </React.Fragment>
                                                                    )}
                                                                </React.Fragment>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="no_report_data">
                                            <h6>
                                                <i className="bi bi-exclamation-circle me-1"></i>
                                                No data found!
                                            </h6>
                                        </div>
                                    )}


                                    {/* Report footer */}
                                    <React.Fragment>
                                        {(reportType === 'Simple' && quotationDetail?.simple_permission_data?.footer) ? (
                                            <div className="report_footer">
                                                <h6>{quotationDetail?.simple_permission_data?.footer}</h6>
                                            </div>
                                        ) : (reportType === 'Detail' && quotationDetail?.detail_permission_data?.footer) ? (
                                            <div className="report_footer">
                                                <h6>{quotationDetail?.detail_permission_data?.footer}</h6>
                                            </div>
                                        ) : footerContent ? (
                                            <div className="report_footer">
                                                <h6>{footerContent}</h6>
                                            </div>
                                        ) : null}
                                    </React.Fragment>

                                    {/* Simple report - Sign */}
                                    {reportType === 'Simple' && isSimpleReportSigned && (
                                        <div className="sv_report_footer">
                                            <div className="sv_report_footer_item">
                                                <h3>
                                                    {quotationDetail?.sign}
                                                </h3>

                                                <h5>PREPARED BY</h5>
                                                <h6>{quotationDetail?.sign_date}</h6>
                                            </div>
                                        </div>
                                    )}

                                    {/* Detail report - Sign */}
                                    {reportType === 'Detail' && isDetailReportSigned && (
                                        <div className="sv_report_footer">
                                            <div className="sv_report_footer_item">
                                                <h3>
                                                    {quotationDetail?.detail_sign}
                                                </h3>

                                                <h5>PREPARED BY</h5>
                                                <h6>{quotationDetail?.detail_sign_date}</h6>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </article>
                        ) : (
                            <div className="page_main_content_section no_header">
                                <NoDataCreated
                                    message={`No data found!`}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>


            {/* Sign and publish modal */}
            <Dialog
                visible={showSignPublishModal}
                header={signPublishModalHeader}
                footer={signPublishModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseSignPublishModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            <div className="col-12">
                                <div className="page_form_group">
                                    <Message
                                        severity='info'
                                        className="message_text"
                                        icon="bi bi-info-circle"
                                        style={{ border: '1px solid', borderRadius: '8px' }}
                                        text={`Once you sign and publish this report, You can able to download and share this report.`}
                                    />
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="page_form_group mb-2 mb-sm-3">
                                    <label
                                        htmlFor="biSignature"
                                        className="custom_form_label is_required"
                                    >
                                        Signature
                                    </label>

                                    <InputText
                                        id="signature"
                                        value={signature}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSignature(e.target.value)}
                                        className="custom_form_input signature_input"
                                        placeholder="Enter the signature"
                                        autoFocus
                                        type="text"
                                    />

                                    {signatureError && (
                                        <small className="form_error_msg">{signatureError}</small>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Mail modal */}
            <Dialog
                header={mailModalHeader}
                footer={mailModalFooter}
                headerClassName="custom_modal_header"
                visible={showMailModal}
                className="custom_modal_dialog modal_dialog_sm"
                onHide={handleCloseMailModal}
                dismissableMask
            >
                <div className="custom_modal_body">
                    <div className="p-1 p-sm-3 pb-sm-0 w-100">
                        <div className="row">
                            <div className="col-12">
                                <TextInput
                                    id="emailAddress"
                                    label="E-mail address"
                                    labelHtmlFor="emailAddress"
                                    required={true}
                                    value={emailAddress}
                                    placeholder="abcd@gmail.com"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                        setEmailAddress(e.target.value)
                                    }
                                    error={emailAddressError}
                                    keyFilter={"email"}
                                    formGroupClassName="mb-2"
                                />

                                {((reportType === 'Simple' && quotationDetail?.simple_report_download_path) ||
                                    (reportType === 'Detail' && quotationDetail?.detail_report_download_path)) && (
                                        <div
                                            className="file_attached_area mb-3"
                                            onClick={handleViewReportDocument}
                                        >
                                            <i className="bi bi-paperclip"></i>
                                            <h6>Quotation report ({reportType}).pdf</h6>
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
            {/*  */}


            {/* Document view modal */}
            <DocumentViewModal
                isOpen={showFileViewModal}
                onClose={handleCloseFileViewModal}
                fileUrl={fileUrl}
            />
            {/*  */}
        </React.Fragment>
    )
}

export default QuotationReport;